/* eslint-disable max-lines-per-function */
import * as Styled from './CaseResultView.styled';

import { Typography } from '@equinor/eds-core-react';
import {
  GetObjectResultsDto,
  GetVariogramResultsDto,
} from '../../../api/generated';
import { ChannelResult } from './ObjectCaseResult/ChannelResult';
import { TanStackTable } from './VariogramCaseResult/VariogramResultTable/TanStackTable/TanStackTable';

export const CaseResultView = ({
  channelResultList,
  variogramResultList,
  type,
}: {
  channelResultList?: GetObjectResultsDto[];
  variogramResultList?: GetVariogramResultsDto[];
  type: string;
}) => {
  return (
    <Styled.CaseResultView>
      <Typography variant="h2">{type} results</Typography>
      <Styled.CaseResultList>
        {variogramResultList && (
          <TanStackTable resultList={variogramResultList}></TanStackTable>
        )}
        {channelResultList &&
          channelResultList.map((obj) => (
            <ChannelResult key={obj.computeCaseId} data={obj}></ChannelResult>
          ))}
      </Styled.CaseResultList>
    </Styled.CaseResultView>
  );
};
